import { dubLogoPrimary, dubLogoReversed, wdayLogoPrimary } from '@workday/canvas-kit-preview-react/common';

const extractSrc = (html: string) => {
    const match = html.match(/src="([^"]+)"/);
    return match ? match[1] : '';
};

export const dubLogoPrimaryUri = extractSrc(dubLogoPrimary);
export const dubLogoReversedUri = extractSrc(dubLogoReversed);
export const wdayLogoPrimaryUri = extractSrc(wdayLogoPrimary);
